import { toast } from "bulma-toast";
import { locale } from "../locale";
import { Bulma } from "./bulma";
import { MaterialDesign } from "./material_design";

/**
 * @param {"large"|"small"} size
 * @param {...Node} children
 */
function centeredBox(size, ...children) {
	/** @type {ColumnSize[]} */
	const classList =
		size === "large"
			? [
					"is-12-mobile",
					"is-11-tablet",
					"is-11-desktop",
					"is-11-widescreen",
					"is-8-fullhd",
				]
			: [
					"is-12-mobile",
					"is-7-tablet",
					"is-6-desktop",
					"is-5-widescreen",
					"is-3-fullhd",
				];

	return Bulma.columns(
		{
			isCentered: true,
			isMobile: true,
		},
		Bulma.column(
			{
				classList: classList,
			},
			Bulma.box(...children),
		),
	);
}

function countrySelect() {
	const comparator = new Intl.Collator(locale.id);
	const countryMap = locale.countries.getNames(locale.id.substring(0, 2));
	const options = Object.entries(countryMap)
		.sort(([_code1, name1], [_code2, name2]) =>
			comparator.compare(name1, name2),
		)
		.map(([code, name]) => {
			const selected = locale.id.substring(3, 5) === code;
			return Bulma.option(name, code, selected);
		});
	return Bulma.select({
		options: options,
	});
}

/**
 * @param {Error | string} err
 */
function errorToast(err) {
	let msg = "";
	if (err instanceof Error) msg = err.message;
	else msg = err;

	toast({
		message: msg,
		type: "is-danger",
		position: "center",
		duration: 3000,
	});
}

/**
 * @param {string} [key=""]
 * @param {string} [value=""]
 */
function keyValueParagraph(key = "", value = "") {
	const k = document.createElement("span");
	k.className = "mr-2";
	k.textContent = key;

	const v = document.createElement("span");
	v.className = "ml-2";
	v.textContent = value;

	const paragraph = document.createElement("p");
	paragraph.className = "spaced";
	paragraph.append(k, v);

	return paragraph;
}

function passwordInput() {
	let isHidden = true;

	const hiddenInput = Bulma.input({
		type: "password",
	});

	const hiddenButton = Bulma.button(
		{},
		MaterialDesign.icon({
			id: "visibility_off",
			onClick: () => {
				visibleInput.setValue(hiddenInput.getValue());
				hiddenInput.element.replaceWith(visibleInput.element);
				hiddenButton.replaceWith(visibleButton);
				isHidden = false;
			},
		}),
	);

	const visibleInput = Bulma.input({
		type: "text",
	});

	const visibleButton = Bulma.button(
		{},
		MaterialDesign.icon({
			id: "visibility",
			onClick: () => {
				hiddenInput.setValue(visibleInput.getValue());
				visibleInput.element.replaceWith(hiddenInput.element);
				visibleButton.replaceWith(hiddenButton);
				isHidden = true;
			},
		}),
	);

	const field = Bulma.field(
		{
			styles: ["has-addons"],
		},
		Bulma.control(
			{
				styles: ["is-expanded"],
			},
			hiddenInput.element,
		),
		Bulma.control({}, hiddenButton),
	);

	return {
		element: field,
		getValue: () =>
			isHidden ? hiddenInput.getValue() : visibleInput.getValue(),
	};
}

/**
 * @param {string} [text=""]
 */
function preformattedText(text = "") {
	const pre = document.createElement("pre");
	pre.className = "is-tiny-mobile";
	pre.textContent = text;
	return pre;
}

function successToast() {
	toast({
		message: MaterialDesign.icon({
			id: "done",
		}),
		type: "is-success",
		duration: 500,
		position: "center",
	});
}

export {
	centeredBox,
	countrySelect,
	errorToast,
	keyValueParagraph,
	passwordInput,
	preformattedText,
	successToast,
};
